module.exports = __webpack_public_path__ + "static/media/logo.437bc8ac.png";